import { fetcher } from '../utils'

export default async (id: number): Promise<void> => fetcher(`/api/defaultMessage/delete/${id}`, 'DELETE', undefined)
